import { toastMessages } from '../constants';
import { newSendApiRequest } from './service-gateway';

export const getUserSettings = async () => {
    return await newSendApiRequest(
        'Settings_read',
        [],
        20000
    );
};

export const saveNotificationSettings = async (selectedFrequency, hasSetting, id) => {
    const response = await newSendApiRequest(
        'Setting_save',
        [
            {
                parameter: 'setting',
                value: JSON.stringify({
                    ...(hasSetting && { "id": id }),
                    "setting": 1,
                    "value": selectedFrequency.value
                })
            }
        ],
        20000
    );

    if (response?.error || typeof response === 'number') {
        throw new Error(response?.error?.message || toastMessages.error.saveFailed);
    }

    return response;
};
